import licensesStyle from '../css/licenses.module.css';

import { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";

import { isNil } from "lodash";

const defaultOverview = {
  expireIn60days: 0,
  total: 0,
  unusedActive: 0,
  unusedInactive: {
    total: 0,
  },
  used: 0
};

const LicenseOverviewContainer = ({
  overviewData,
  onSearch
}) => {
  const { t } = useTranslation();
  const [overview, setOverview] = useState(defaultOverview);

  useEffect(() => {
    if (!isNil(overviewData)) {
      setOverview(overview => (overviewData));
    }
  }, [overviewData]);

  return (
    <Container className={licensesStyle['devices-overview-container']}>
      <Row>
        <Col className={licensesStyle['devices-status-container']}>
          <div className={licensesStyle['sub-status-container']}>
            <div className={licensesStyle['number-container']}>
              <div className={licensesStyle['number-title']}>
                {t('920291f7c4')}
              </div>
              <a
                href="#/"
                className={licensesStyle['number-count']}
                onClick={() => onSearch('expireIn60days')}
              >
                {overview?.expireIn60days}
              </a>
            </div>
          </div>

          <div className={licensesStyle['sub-status-container']}>
            <div className={licensesStyle['number-container']}>
              <div className={licensesStyle['number-title']}>
                {t('0c714f58b7')}
              </div>
              <a
                href="#/"
                className={licensesStyle['number-count']}
                onClick={() => onSearch('used')}
              >
                {overview?.used}
              </a>
            </div>
          </div>

          <div className={licensesStyle['sub-status-container']}>
            <div className={licensesStyle['number-container']}>
              <div className={licensesStyle['number-title']}>
                {t('57c5db4082')}
              </div>
              <a
                href="#/"
                className={licensesStyle['number-count']}
                onClick={() => onSearch('unusedInactive')}
              >
                {overview?.unusedInactive?.total}
              </a>
            </div>
          </div>

          <div className={licensesStyle['sub-status-container']}>
            <div className={licensesStyle['number-container']}>
              <div className={licensesStyle['number-title']}>
                {t('c78b6db4ce')}
              </div>
              <a
                href="#/"
                className={licensesStyle['number-count']}
                onClick={() => onSearch('unusedActive')}
              >
                {overview?.unusedActive}
              </a>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default LicenseOverviewContainer;